"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LtarGeneralHandler", {
    enumerable: true,
    get: function() {
        return LtarGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _handlerUtils = require("~/db/field-handler/utils/handlerUtils");
const _generic = require("~/db/field-handler/handlers/generic");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
let LtarGeneralHandler = class LtarGeneralHandler extends _generic.GenericFieldHandler {
    async filter(knex, filter, column, options) {
        const { context, alias, baseModel: baseModelSqlv2, depth: aliasCount, throwErrorIfInvalid, conditionParser: parseConditionV2 } = options;
        const isMMLike = (0, _nocodbsdk.isMMOrMMLike)(column);
        const colOptions = await column.getColOptions(context);
        let rootApply = undefined;
        const { parentContext, childContext, mmContext } = await colOptions.getParentChildContext(context, column);
        const childColumn = await colOptions.getChildColumn(context);
        const parentColumn = await colOptions.getParentColumn(context);
        const childModel = await childColumn.getModel(childContext);
        await childModel.getColumns(childContext);
        const parentModel = await parentColumn.getModel(parentContext);
        await parentModel.getColumns(parentContext);
        let relationType = isMMLike ? _nocodbsdk.RelationTypes.MANY_TO_MANY : colOptions.type;
        if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
            var _column_meta;
            relationType = ((_column_meta = column.meta) == null ? void 0 : _column_meta.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
        }
        if (relationType === _nocodbsdk.RelationTypes.HAS_MANY) {
            var _childModel_displayValue;
            const childTableAlias = (0, _handlerUtils.getAlias)(aliasCount);
            const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                model: childModel,
                dbDriver: baseModelSqlv2.dbDriver
            });
            // Knex's TypeScript definitions do not correctly infer knex.raw() or knex.ref()
            // as valid column references. This causes type errors when used in query builders
            // like `whereIn()`, `where()`, and `select()`. Casting to `any` ensures proper
            // SQL generation while avoiding TypeScript issues.
            const childColumnRef = knex.raw('??.??', [
                childTableAlias,
                childColumn.column_name
            ]);
            const parentColumnRef = knex.raw('??.??', [
                alias || baseModelSqlv2.getTnPath(parentModel.table_name),
                parentColumn.column_name
            ]);
            if ([
                'blank',
                'notblank',
                'checked',
                'notchecked'
            ].includes(filter.comparison_op)) {
                const selectHmCount = knex(childBaseModel.getTnPath(childModel.table_name, childTableAlias)).count(childColumn.column_name).whereRaw('?? = ??', [
                    childColumnRef,
                    parentColumnRef
                ]);
                return {
                    rootApply,
                    clause: (qb)=>{
                        if (filter.comparison_op === 'blank') {
                            qb.where(knex.raw('0'), selectHmCount);
                        } else {
                            qb.whereNot(knex.raw('0'), selectHmCount);
                        }
                    }
                };
            }
            const selectQb = knex(childBaseModel.getTnPath(childModel.table_name, childTableAlias)).select(childColumnRef);
            const parseOperationResult = await parseConditionV2(childBaseModel, new _models.Filter(_extends({}, filter, filter.comparison_op in _handlerUtils.negatedMapping ? _handlerUtils.negatedMapping[filter.comparison_op] : {}, {
                fk_model_id: childModel.id,
                fk_column_id: childModel == null ? void 0 : (_childModel_displayValue = childModel.displayValue) == null ? void 0 : _childModel_displayValue.id
            })), aliasCount, childTableAlias, undefined, throwErrorIfInvalid);
            parseOperationResult.clause(selectQb);
            rootApply = (qb)=>{
                parseOperationResult.rootApply == null ? void 0 : parseOperationResult.rootApply.call(parseOperationResult, qb);
            };
            return {
                rootApply,
                clause: (qbP)=>{
                    if (filter.comparison_op in _handlerUtils.negatedMapping) qbP.whereNotIn(parentColumnRef, selectQb);
                    else qbP.whereIn(parentColumnRef, selectQb);
                }
            };
        } else if (relationType === _nocodbsdk.RelationTypes.BELONGS_TO) {
            var _parentModel_displayValue;
            const parentTableAlias = (0, _handlerUtils.getAlias)(aliasCount);
            const childTableAlias = alias || baseModelSqlv2.getTnPath(childModel.table_name);
            const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                model: parentModel,
                dbDriver: baseModelSqlv2.dbDriver
            });
            // Knex's TypeScript definitions do not correctly infer knex.raw() or knex.ref()
            // as valid column references. This causes type errors when used in query builders
            // like `whereIn()`, `where()`, and `select()`. Casting to `any` ensures proper
            // SQL generation while avoiding TypeScript issues.
            const parentColumnRef = knex.raw('??.??', [
                parentTableAlias,
                parentColumn.column_name
            ]);
            const childColumnRef = knex.raw('??.??', [
                childTableAlias,
                childColumn.column_name
            ]);
            if ([
                'blank',
                'notblank',
                'checked',
                'notchecked'
            ].includes(filter.comparison_op)) {
                // handle self reference
                if (parentModel.id === childModel.id) {
                    if (filter.comparison_op === 'blank') {
                        return {
                            rootApply,
                            clause: (qb)=>{
                                qb.whereNull(childColumnRef);
                            }
                        };
                    } else {
                        return {
                            rootApply,
                            clause: (qb)=>{
                                qb.whereNotNull(childColumnRef);
                            }
                        };
                    }
                }
                const selectBtCount = knex(parentBaseModel.getTnPath(parentModel.table_name, parentTableAlias)).count(parentColumnRef).where(parentColumnRef, childColumnRef);
                return {
                    rootApply,
                    clause: (qb)=>{
                        if (filter.comparison_op === 'blank') {
                            qb.where(knex.raw('0'), selectBtCount);
                        } else {
                            qb.whereNot(knex.raw('0'), selectBtCount);
                        }
                    }
                };
            }
            const selectQb = knex(parentBaseModel.getTnPath(parentModel.table_name, parentTableAlias)).select(parentColumn.column_name);
            const parseOperationResult = await parseConditionV2(parentBaseModel, new _models.Filter(_extends({}, filter, filter.comparison_op in _handlerUtils.negatedMapping ? _handlerUtils.negatedMapping[filter.comparison_op] : {}, {
                fk_model_id: parentModel.id,
                fk_column_id: parentModel == null ? void 0 : (_parentModel_displayValue = parentModel.displayValue) == null ? void 0 : _parentModel_displayValue.id
            })), aliasCount, parentTableAlias, undefined, throwErrorIfInvalid);
            parseOperationResult.clause(selectQb);
            rootApply = (qb)=>{
                parseOperationResult.rootApply == null ? void 0 : parseOperationResult.rootApply.call(parseOperationResult, qb);
            };
            return {
                rootApply,
                clause: (qbP)=>{
                    if (filter.comparison_op in _handlerUtils.negatedMapping) {
                        qbP.where((qb)=>qb.whereNotIn(childColumnRef, selectQb).orWhereNull(childColumnRef));
                    } else qbP.whereIn(childColumnRef, selectQb);
                }
            };
        } else if (relationType === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
            var _parentModel_displayValue1;
            const childTableAliasOrRef = alias || baseModelSqlv2.getTnPath(childModel.table_name);
            const parentTableAlias = (0, _handlerUtils.getAlias)(aliasCount);
            const mmTableAlias = (0, _handlerUtils.getAlias)(aliasCount);
            const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                model: parentModel,
                dbDriver: baseModelSqlv2.dbDriver
            });
            const mmModel = await colOptions.getMMModel(context);
            const mmParentColumn = await colOptions.getMMParentColumn(context);
            const mmChildColumn = await colOptions.getMMChildColumn(context);
            const assocBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                model: mmModel,
                dbDriver: baseModelSqlv2.dbDriver
            });
            // Knex's TypeScript definitions do not correctly infer knex.raw() or knex.ref()
            // as valid column references. This causes type errors when used in query builders
            // like `whereIn()`, `where()`, and `select()`. Casting to `any` ensures proper
            // SQL generation while avoiding TypeScript issues.
            const childColumnRef = knex.raw('??.??', [
                childTableAliasOrRef,
                childColumn.column_name
            ]);
            const parentColumnRef = knex.raw('??.??', [
                parentTableAlias,
                parentColumn.column_name
            ]);
            const mmParentColumnRef = knex.raw('??.??', [
                mmTableAlias,
                mmParentColumn.column_name
            ]);
            const mmChildColumnRef = knex.raw('??.??', [
                mmTableAlias,
                mmChildColumn.column_name
            ]);
            if ([
                'blank',
                'notblank',
                'checked',
                'notchecked'
            ].includes(filter.comparison_op)) {
                // handle self reference
                if (mmModel.id === childModel.id) {
                    if (filter.comparison_op === 'blank') {
                        return {
                            rootApply,
                            clause: (qb)=>{
                                qb.whereNull(childColumnRef);
                            }
                        };
                    } else {
                        return {
                            rootApply,
                            clause: (qb)=>{
                                qb.whereNotNull(childColumnRef);
                            }
                        };
                    }
                }
                const selectMmCount = knex(assocBaseModel.getTnPath(mmModel.table_name, mmTableAlias)).count(mmChildColumnRef).where(mmChildColumnRef, childColumnRef);
                return {
                    rootApply,
                    clause: (qb)=>{
                        if (filter.comparison_op === 'blank') {
                            qb.where(knex.raw('0'), selectMmCount);
                        } else {
                            qb.whereNot(knex.raw('0'), selectMmCount);
                        }
                    }
                };
            }
            const selectQb = knex(assocBaseModel.getTnPath(mmModel.table_name, mmTableAlias)).select(mmChildColumnRef).join(parentBaseModel.getTnPath(parentModel.table_name, parentTableAlias), mmParentColumnRef, parentColumnRef);
            const parseOperationResult = await parseConditionV2(parentBaseModel, new _models.Filter(_extends({}, filter, filter.comparison_op in _handlerUtils.negatedMapping ? _handlerUtils.negatedMapping[filter.comparison_op] : {}, {
                fk_model_id: parentModel.id,
                fk_column_id: parentModel == null ? void 0 : (_parentModel_displayValue1 = parentModel.displayValue) == null ? void 0 : _parentModel_displayValue1.id
            })), aliasCount, parentTableAlias, undefined, throwErrorIfInvalid);
            parseOperationResult.clause(selectQb);
            rootApply = (qb)=>{
                parseOperationResult.rootApply == null ? void 0 : parseOperationResult.rootApply.call(parseOperationResult, qb);
            };
            return {
                rootApply,
                clause: (qbP)=>{
                    if (filter.comparison_op in _handlerUtils.negatedMapping) qbP.where((qb)=>qb.whereNotIn(childColumnRef, selectQb).orWhereNull(childColumnRef));
                    else qbP.whereIn(childColumnRef, selectQb);
                }
            };
        }
        return {
            rootApply,
            clause: (_qb)=>{}
        };
    }
};
